document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("header");
  const adminBar = document.getElementById("wpadminbar");
  const nav = document.getElementById("projects-nav");

  // Get dynamic heights
  function getOffsetHeight() {
    const headerHeight = header ? header.offsetHeight : 0;
    const adminHeight = adminBar ? adminBar.offsetHeight : 0;
    return headerHeight + adminHeight;
  }

  // Update nav position (optional, adjust as needed)
  function updateNavPosition() {
    if (!nav) return;
    const offset = getOffsetHeight();
    nav.style.top = offset +20 + "px"; // set sticky nav top offset
  }

  // Scroll with smooth behavior and header offset
  function scrollToHash(hash) {
    const target = document.querySelector(hash);
    if (!target) return;

    const offset = getOffsetHeight();
    const targetTop = target.getBoundingClientRect().top + window.scrollY;
    const scrollTop = targetTop - offset;

    window.scrollTo({
      top: scrollTop,
      behavior: "smooth",
    });
  }

  // Instant scroll (used on resize or first load)
  function instantScrollToHash(hash) {
    const target = document.querySelector(hash);
    if (!target) return;

    const scrollTop = target.getBoundingClientRect().top + window.scrollY - getOffsetHeight();

    window.scrollTo({
      top: scrollTop,
      behavior: "auto",
    });
  }

  // Initial nav position
  updateNavPosition();

  // Scroll on page load if URL contains hash
  if (window.location.hash && document.querySelector(window.location.hash)) {
    setTimeout(() => {
      scrollToHash(window.location.hash);
    }, 100);
  }

  // Scroll on anchor click
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      const hash = this.getAttribute("href");
      const target = document.querySelector(hash);
      if (!target) return;

      // If target contains a collapsed accordion, expand it first
      const accordionButton = target.querySelector(".accordion-button");
      if (accordionButton && accordionButton.classList.contains("collapsed")) {
        accordionButton.click(); // Let Bootstrap handle the expansion
      }

      e.preventDefault(); // Prevent default anchor behavior
      history.pushState(null, "", hash); // Update URL

      // Scroll after expansion delay
      setTimeout(() => {
        scrollToHash(hash);
      }, 300); // Delay must match Bootstrap accordion transition
    });
  });

  // Recalculate offset and scroll position on resize
  window.addEventListener("resize", function () {
    updateNavPosition();

    if (window.location.hash && document.querySelector(window.location.hash)) {
      instantScrollToHash(window.location.hash);
    }
  });
});
